module.exports = __webpack_public_path__ + "static/img/安全审计.3608f6e3.png";